/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorCounselingCountGroupedByPharmacyIDTime,
  PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSON,
  PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSONTyped,
  PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeToJSON,
} from "./";

export const GetCounselingCountResponseTypename = "GetCounselingCountResponse" as const;

/**
 *
 * @export
 * @interface GetCounselingCountResponse
 */
export interface GetCounselingCountResponse {
  /**
   *
   * @type {number}
   * @memberof GetCounselingCountResponse
   */
  count?: number;
  /**
   * exists only if group_by query parameter is set
   * @type {Array<PharmacyCounselorCounselingCountGroupedByPharmacyIDTime>}
   * @memberof GetCounselingCountResponse
   */
  countsGroupedByPharmacyIdTime?: Array<PharmacyCounselorCounselingCountGroupedByPharmacyIDTime>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetCounselingCountResponse
   */
  readonly __typename?: string;
}

export function GetCounselingCountResponseFromJSON(json: any): GetCounselingCountResponse {
  return GetCounselingCountResponseFromJSONTyped(json, false);
}

export function GetCounselingCountResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCounselingCountResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetCounselingCountResponseTypename,

    count: !exists(json, "count") ? undefined : json["count"],
    countsGroupedByPharmacyIdTime: !exists(json, "counts_grouped_by_pharmacy_id_time")
      ? undefined
      : (json["counts_grouped_by_pharmacy_id_time"] as Array<any>).map(
          PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSON
        ),
  };
}

export function GetCounselingCountResponseToJSON(object?: GetCounselingCountResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    count: value.count,
    counts_grouped_by_pharmacy_id_time:
      value.countsGroupedByPharmacyIdTime === undefined
        ? undefined
        : (value.countsGroupedByPharmacyIdTime as Array<any>).map(
            PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeToJSON
          ),
  };
}
